import { FC } from 'react';

import { Heading } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { getVariationTitle } from './getVariationTitle';
import { BadgeBlockTitleProps } from './model';
import { BadgeBlockOutOfStockLabel, BadgeBlockTitle } from './ProductVariationBadges.styles';

export const BadgeBlockTitleByAlias: FC<BadgeBlockTitleProps> = ({ variation, id }) => {
    const { t } = useTranslations();

    const title = getVariationTitle(variation, t);
    const showOutOfStockLabel = variation?.isOutOfStock;

    if (!title) {
        return null;
    }

    return (
        <BadgeBlockTitle>
            <Heading id={id} tag="h2" variant="subsection-100">
                {title}
            </Heading>
            {showOutOfStockLabel && (
                <BadgeBlockOutOfStockLabel aria-label={t['eshop.product_page.stock_status.out_of_stock']}>
                    {t['eshop.product_page.stock_status.out_of_stock']}
                </BadgeBlockOutOfStockLabel>
            )}
        </BadgeBlockTitle>
    );
};
